import { SystemlogModel } from 'src/Libs/installations/models'
import { SystemlogType } from 'src/Libs/installations/types'

// 49155 = 0xC003
export const SMART_METER_GATEWAY_LOG_ERROR_CODE = 49155

/**
 * Checks whether a system log asks the user to adjust the smart meter gateway settings.
 * Such logs can't be resolved manually, the portal resolves them once the smart meter gateway SKI is trusted.
 */
export const isSmartMeterGatewayLog = (log: Pick<SystemlogModel, 'errorType' | 'errorCode'>): boolean =>
  log.errorType === SystemlogType.Notice && log.errorCode === SMART_METER_GATEWAY_LOG_ERROR_CODE
